module.exports = __webpack_public_path__ + "img/whole-life-critical-illness-insurance-filled.b536846.png";